import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next"; // ✅ Needed to change i18n language

// Get locale from cookie
const getLocale = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

// Fetch Strapi Data Hook
const useFetchStrapiData = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";
  const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN;
  const locale = getLocale();

  useEffect(() => {
    const fetchData = async () => {
      if (!STRAPI_URL || !STRAPI_TOKEN) return;

      const url = new URL(`${STRAPI_URL}/api/events`);
      url.searchParams.set("locale", locale);
      url.searchParams.set("sort", "startDate:desc");

      try {
        const res = await fetch(url, {
          headers: {
            Authorization: `Bearer ${STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
        const result = await res.json();
        setData(result.data || []);
      } catch (err) {
        console.error("❌ Fetch error:", err);
        setError(err.message);
      }
    };

    fetchData();
  }, [STRAPI_URL, STRAPI_TOKEN, locale]);

  return { data, error, locale };
};

const AllEvents = () => {
  const { data, error, locale } = useFetchStrapiData();
  const { t } = useTranslation();

  // ✅ Sync i18n language with cookie-based locale
  if (i18n.language !== locale) {
    i18n.changeLanguage(locale);
  }

  if (error) {
    return <h1>{t("global.error")}: {error}</h1>;
  }

  return (
    <div className="container mt-5 mb-10">
      <ol className="list-group list-group-separated col-12">
        {data.map((item) => {
          const attributes = item.attributes || item;
          const { title, slug, startDate, endDate, locationName } = attributes;

          return (
            <a
              href={`/events/${slug}`}
              className="list-group-item d-flex justify-content-between align-items-start text-black"
              key={item.id}
            >
              <span>
                <h4 style={{ fontWeight: "bold", lineHeight: "90%" }} className="mb-0">
                  {title}
                </h4>
                <small className="text-black eyebrow d-block mt-0">
                  {startDate && (
                    <>
                      {new Date(startDate).toLocaleDateString(locale, {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </>
                  )}
                  {endDate && (
                    <>
                      {" · "}
                      {new Date(endDate).toLocaleDateString(locale, {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </>
                  )}
                  {locationName && (
                    <>
                      {" · "}
                      {locationName}
                    </>
                  )}
                </small>
              </span>
              <h4 className="mt-0" style={{ fontWeight: "bold", lineHeight: "90%" }}>
                <i className="bi bi-arrow-right"></i>
              </h4>
            </a>
          );
        })}
      </ol>
    </div>
  );
};

export default AllEvents;
